// src/MoneyProfit.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var MoneyProfit_default = createIcon({
  displayName: "MoneyProfit",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.748 2C13.082 2 12.7497 2.80439 13.2207 3.27539L14.2656 4.32031L13 5.58594L10.707 3.29297C10.3165 2.9026 9.6835 2.9026 9.29297 3.29297L6.29297 6.29297C6.03173 6.54379 5.9265 6.91623 6.01786 7.26667C6.10922 7.61711 6.38289 7.89078 6.73333 7.98214C7.08377 8.0735 7.45621 7.96827 7.70703 7.70703L10 5.41406L12.293 7.70703C12.6835 8.0974 13.3165 8.0974 13.707 7.70703L15.6797 5.73438L16.7227 6.7793C17.1947 7.2513 18 6.91795 18 6.25195V3.00977C18 2.45277 17.5472 2 16.9902 2H13.748ZM3 10C2.448 10 2 10.448 2 11V21C2 21.552 2.448 22 3 22H21C21.552 22 22 21.552 22 21V11C22 10.448 21.552 10 21 10H3ZM4.91211 12H19.0879C19.239 12.4259 19.5741 12.761 20 12.9121V19.0879C19.5741 19.239 19.239 19.5741 19.0879 20H4.91211C4.761 19.5741 4.42591 19.239 4 19.0879V12.9121C4.42591 12.761 4.761 12.4259 4.91211 12ZM12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13ZM7 15C6.448 15 6 15.447 6 16C6 16.553 6.448 17 7 17C7.552 17 8 16.553 8 16C8 15.447 7.552 15 7 15ZM17 15C16.448 15 16 15.447 16 16C16 16.553 16.448 17 17 17C17.552 17 18 16.553 18 16C18 15.447 17.552 15 17 15Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  MoneyProfit_default
};
